import { createUseStyles } from 'react-jss'
import { black } from '../../../../../styles/const/colors'

export default createUseStyles({
  actionButton: {
    border: `1px solid ${black}`,
    borderRadius: 3,
    cursor: 'pointer',
    height: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 8,
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    lineHeight: 1,
    padding: '2px 4px'
  },
  skeletonButtonLine: {
    minWidth: 40,
    maxHeight: 7,
    height: 7,
    margin: 0
  }
})
